import { getAppConfig } from '@/config/env'
import { MarketCalendar } from '@/components/calendar/MarketCalendar'
import { WelcomeHero } from '@/components/welcome/WelcomeHero'

import styles from './WelcomePage.module.css'

/**
 * Landing page composed around the Oikos Market Day flyer energy.
 */
export function WelcomePage() {
  const { appName } = getAppConfig()

  return (
    <div className={styles.page}>
      <WelcomeHero appName={appName} />

      <section className={styles.strip} aria-label="What to expect">
        <div className={styles.chalkboard}>
          <p className={styles.chalkTitle}>What you’ll find</p>
          <ul className={styles.chalkList}>
            <li><span className={styles.dotLime} /> Fresh produce</li>
            <li><span className={styles.dotOrange} /> Crafts &amp; décor</li>
            <li><span className={styles.dotPink} /> Food &amp; treats</li>
            <li><span className={styles.dotSky} /> Plants &amp; flowers</li>
            <li><span className={styles.dotLime} /> Kids’ corner</li>
            <li><span className={styles.dotOrange} /> Coffee &amp; chill</li>
          </ul>
        </div>

        <div className={styles.infoBadge}>
          <p className={styles.badgeEyebrow}>Every month</p>
          <p className={styles.badgeBody}>Oikos Private School, 0 Pilgrim Street, Barberton</p>
          <p className={styles.badgeSchedule}>
            Open 08:00–13:00 · last weekend of every month
          </p>
          <p className={styles.badgeMeta}>Stalls from R100 · R150 with power</p>
        </div>

        <div className={styles.supportBoard}>
          <p className={styles.supportTitle}>Support local</p>
          <p className={styles.supportCopy}>
            Vendors keep all their profits. Register your stall online, then come shop,
            eat, and enjoy a fun-filled day with the Oikos community.
          </p>
        </div>
      </section>

      <MarketCalendar />
    </div>
  )
}
